import { Button, Form, Input, message } from 'antd'
import React, { useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useFetch } from '../../services/ApiService';

function ForgotPassword() {

  const forgotPasswordFormRef = useRef();
  const changePasswordFormRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const [forgotPassState, setForgotPassState] = useState(true);
  const navigate = useNavigate();
  const { fetchApi } = useFetch();

  const handleForgotPassword = async (values) => {
    setBtnLoading(true);

    await fetchApi('/api/forgot_password', 'POST', values).then(res => {
      message.success('An OTP has been sent to your registered email.')
      setForgotPassState(false);
    }).catch(err => {
      console.log(err);
    })
    
    setBtnLoading(false);

  }

  const handleChangePassword = async (values) => {

    setBtnLoading(true);

    await fetchApi('/api/verify_otp', 'POST', values).then(res => {
      message.success('OTP Verified. Your password has been changed successfully.');
      navigate('/');
      setForgotPassState(true);
    }).catch(err => {
      console.log(err);
    })

    
    setBtnLoading(false);
  }


  return (

    <>
      {
        forgotPassState ?
          <>
            <div className='login-title'>
              <h1 className='mb-1'>Forgot Password?</h1>
              <p className='small'>Enter your email to recieve OTP.</p>
            </div>
            <Form
              name="fp-form"
              ref={forgotPasswordFormRef}
              layout="vertical"
              onFinish={handleForgotPassword}
              autoComplete='off'
            >
              <Form.Item
                label="Email"
                name="email"

                rules={[
                  {
                    required: true,
                    message: 'Email is required',
                  },

                ]}
              >
                <Input placeholder='Enter username' />
              </Form.Item>

              <Button loading={btnLoading} block type="primary" className='px-5 fw-semibold' htmlType="submit" size="large">SEND</Button>
              <p className='mt-4 mb-0 text-center text-muted'>Go back to <Link to='/' className='text-primary'>Login</Link></p>
            </Form>
          </>
          :
          <>
            <div className='login-title'>
              <h1 className='mb-1'>Change Password</h1>
              <p className='small'>Enter your following details to change password.</p>
            </div>
            <Form
              name="cp-form"
              ref={changePasswordFormRef}
              layout="vertical"
              onFinish={handleChangePassword}
              autoComplete='off'
            >
              <Form.Item
                label="Email"
                name="email"

                rules={[
                  {
                    required: true,
                    message: 'Email is required',
                  },

                ]}
              >
                <Input disabled placeholder='Enter username' />
              </Form.Item>
              <Form.Item
                label="One Time Password"
                name="otp"

                rules={[
                  {
                    required: true,
                    message: 'OTP is required',
                  },

                ]}
              >
                <Input placeholder='Enter OTP' />
              </Form.Item>
              <Form.Item
                label="New Password"
                name="password"

                rules={[
                  {
                    required: true,
                    message: 'Password is required',
                  },

                ]}
              >
                <Input.Password placeholder='Enter New Password' />
              </Form.Item>

              <Button loading={btnLoading} block type="primary" className='px-5 fw-semibold' htmlType="submit" size="large">Change Password</Button>
              <p className='mt-4 mb-0 text-center text-muted'>Go back to <Link to='/' className='text-primary'>Login</Link></p>
            </Form>
          </>
      }

    </>
  )
}

export default ForgotPassword